export const parseQueryParams = (queryParams: string | undefined) => {
	if (!queryParams) return {};
	const queryParamsSegments = queryParams.replace('?', '').split('&');
	const newQueryParamsObject = queryParamsSegments.reduce(
		(acc, segment) => {
			const [key, value] = segment.split('=');
			let cleanKey = key.replace('[]', '');
			if (cleanKey.includes('frameworkcontract')) {
				cleanKey = cleanKey.replace('frameworkcontract', 'frameworkContract');
			}
			if (!value) {
				acc[cleanKey] = acc[cleanKey] || [];
			} else {
				const values = value.split(',');
				acc[cleanKey] = [...(acc[cleanKey] || []), ...values];
			}
			return acc;
		},
		{} as Record<string, string[]>,
	);
	return newQueryParamsObject;
};

const encodeIfNeeded = (value: string) => {
	try {
		// se decodeURIComponent non cambia il valore, significa che non era codificato
		return decodeURIComponent(value) === value ? encodeURIComponent(value) : value;
	} catch {
		// se fallisce il decode, significa che non era codificato → codifica
		return encodeURIComponent(value);
	}
};

export const wrapQueryParams = (queryParams: Record<string, string[]>) => {
	return Object.entries(queryParams)
		.sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
		.map(([key, value], index) => {
			if (value.length === 0) {
				return '';
			}
			let cleanKey = key;
			if (key.includes('frameworkContract')) cleanKey = key.replace('frameworkContract', 'frameworkcontract');
			if (value.length > 1 || key === 'document_codes') {
				const valuesArray = value.map((val, subIndex) => {
					const prefix = index === 0 && subIndex === 0 ? '?' : '&';
					const bracket = '[]';
					return `${prefix}${encodeIfNeeded(cleanKey)}${bracket}=${encodeIfNeeded(val)}`;
				});
				return valuesArray.join('');
			}
			const prefix = index === 0 ? '?' : '&';
			return `${prefix}${encodeIfNeeded(cleanKey)}=${encodeIfNeeded(value.join(''))}`;
		})
		.join('');
};
